import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrightcovePlayerComponent } from '@df/ui/display/media/brightcove/brightcove-player.component';
import { Media } from '@df/ui/display/media/interfaces';
import { VideoPlayerComponent } from '@df/ui/display/media/video-player.component';
import { VimeoPlayerComponent } from '@df/ui/display/media/vimeo-player.component';
import { YoutubePlayerComponent } from '@df/ui/display/media/youtube-player.component';
import { DeepPartial } from '@df/util/type/deep-partial';
import { providers } from './media.providers';

@NgModule({
    imports: [VideoPlayerComponent, YoutubePlayerComponent, VimeoPlayerComponent, BrightcovePlayerComponent],
    exports: [VideoPlayerComponent, YoutubePlayerComponent, VimeoPlayerComponent, BrightcovePlayerComponent]
})
export class MediaModule {
    static forRoot(config?: DeepPartial<Media.IConfig>): ModuleWithProviders<MediaModule> {
        return {
            ngModule: MediaModule,
            providers: providers(config)
        };
    }
}
